/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_calculator = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	var _calculated = 0;
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.onready = function() {

		/*
		Input 1
		*/
		$('.js-input-1').keyup(function(){

			specific_calculator.calculate();

			if(
				$(this).val() != ''
			) {
				
				$('.js-input-2').removeAttr('disabled');
				$('.js-input-2-outside').addClass('active');

			} else {

				$('.js-input-2').removeAttr('disabled');
				$('.js-input-2-outside').removeClass('active');
				$('.js-input-3').attr('disabled');
				$('.js-input-3-outside').removeClass('active');
				$('.js-input-4').attr('disabled');
				$('.js-input-4-outside').removeClass('active');
			}

		});

		/*
		Input 2
		*/
		$('.js-input-2-a').change(function(){

			specific_calculator.calculate();

			if(
				$(this).val() != '' &&
				$(this).val() != 'none'
			) {

				/*
				Make the rest 100%
				*/
				if($(this).val() > 100) {
					
					$(this).val(100);
					$('.js-input-2-b').val(0);

				} else {

					var _rest = (100 - $(this).val());
					$('.js-input-2-b').val(_rest);

				}

				$('.js-input-3').removeAttr('disabled');
				$('.js-input-3-outside').addClass('active');

			} else {

				$('.js-input-3').attr('disabled');
				$('.js-input-3-outside').removeClass('active');
				$('.js-input-4').attr('disabled');
				$('.js-input-4-outside').removeClass('active');
			}

		});


		$('.js-input-2-b').change(function(){

			specific_calculator.calculate();

			if(
				$(this).val() != '' &&
				$(this).val() != 'none'
			) {

				/*
				Make the rest 100%
				*/
				if($(this).val() > 100) {
					
					$(this).val(100);
					$('.js-input-2-a').val(0);

				} else {

					var _rest = (100 - $(this).val());
					$('.js-input-2-a').val(_rest);

				}

				$('.js-input-3').removeAttr('disabled');
				$('.js-input-3-outside').addClass('active');

			} else {

				$('.js-input-3').attr('disabled');
				$('.js-input-3-outside').removeClass('active');
				$('.js-input-4').attr('disabled');
				$('.js-input-4-outside').removeClass('active');
			}

		});

		/*
		Input 3
		*/
		$('.js-input-3').change(function(){

			specific_calculator.calculate();

			if(
				$(this).val() != '' &&
				$(this).val() != 'none'
			) {

				$('.js-input-4').removeAttr('disabled');
				$('.js-input-4-outside').addClass('active');

			} else {

				$('.js-input-4').attr('disabled');
				$('.js-input-4-outside').removeClass('active');
			}

		});

		/*
		Input 4
		*/
		$('.js-input-4').keyup(function(){

			specific_calculator.calculate();

			/*
			Show or not
			*/
			if(
				$(this).val() != ''
			) {

				$('.js-calculator-results').slideDown();

				_calculated = 1;

			} else {
				
				$('.js-calculator-results').slideUp();

				_calculated = 0;
			}

		});
		
	};

	/*
	Calculate *************************
	Calculate *************************
	Calculate *************************
	Calculate *************************
	*/
	this.calculate = function() {

		/*
		Calculate
		*/
		var _input1 					= $('.js-input-1').val(); 	// bezoekers per maand
		var _input2a 					= $('.js-input-2-a').val(); // percentage desktop bezoekers
		var _input2b 					= $('.js-input-2-b').val(); // percentage desktop mobiel

		var _desktop_visitors 			= _input2a / 100;
		_desktop_visitors 				= Math.round(_desktop_visitors * _input1);
		var _mobile_visitors 			= _input2b / 100;
		_mobile_visitors 				= Math.round(_mobile_visitors * _input1);

		var _input3 					= $('.js-input-3').val(); // conversie percentage
		var _input4 					= $('.js-input-4').val(); // gemiddeld conversiewaarde

		var _exitpercentage 			= ((100 - _input3) / 100);

		var _extra_conversie			= Math.round(0.55 * _desktop_visitors * _exitpercentage * 0.10) + Math.round(0.40 * _mobile_visitors * _exitpercentage * 0.07);

		var _huidigepercentageopdesktop = (_input3 / 100) * _desktop_visitors;

		var _percentage_nieuwe_conversiepercentage = ((_huidigepercentageopdesktop + _extra_conversie) / _desktop_visitors) * 100;

		var _extra_omzet 				= Math.round(_extra_conversie * _input4);

		var _totaal 					= ((_input3 / 100) * _input1); 
		var _percentage_nieuwe_conversiepercentage2 = ((_totaal + _extra_conversie) / _input1) * 100;

		/*
		Set
		*/
		$('.js-calculated-1').html(_input3 + '% > ' + Math.round(_percentage_nieuwe_conversiepercentage) + '%');
		$('.js-calculated-2').html('&euro;' + _extra_omzet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
		$('.js-calculated-3').html(_input3 + '% > ' + Math.round(_percentage_nieuwe_conversiepercentage2) + '%');

		if(_marcsenseretain_active == 1) {

			/*
	    	Scroll percentage
	    	*/
	    	var scrollTop 				= $(window).scrollTop();
			var docHeight 				= $(document).height();
			var winHeight 				= $(window).height();
			var scrollPercent 			= (scrollTop) / (docHeight - winHeight);
			var scrollPercentRounded 	= Math.round(scrollPercent*100);

			window.celebrusSendJsonData(
		    	{"events":[
		    		{
		    			"eventType" 	: "PageDepthEvent",
		    			"eventGroup"	: "Scenario",

		    			"ViewDepth" 	: scrollPercentRounded,
		    			"ViewedElement"	: 'Calulator: calculatie gedaan'
		    		}
		    	]
			},2);
			
		}


	};
		
}).apply(specific_calculator); 